import  axios from 'axios'
export const fetchImports = async ({page, search, per_page, sort}) => {
    let currentPage = page || 1
    let perPage = per_page || 10
    let searchValue = search || ''
    let response
    try {
        response = await axios({
        method:'get',
        url:`/imports?page=${currentPage}&sort=${sort.value}&direction=${sort.direction}&per_page=${perPage}${searchValue? `&search=${searchValue}` : ''}`
    })}catch(e) {
        console.log(e)
    }

    return response.data
}
export const fetchImport = async (id) => {
    let response = await axios({
        method:'get',
        url:`/imports/${id}`
    })
    return response.data
}
export const createImport = async (theImport) => {
    let response = await axios({
        method:'post',
        url:`/imports`,
        data: theImport
    })
    return response.data
}
export const downloadImport = async (id) => {
    let response = await axios({
        method:'post',
        url:`/imports/${id}/download`
    })
    return response.data
}
export const processImport = async (id) => {
    let response = await axios({
        method:'post',
        url:`/imports/${id}/process`
    })
    return response.data
}


export const fetchImportReports = async ({id,page, search, per_page, sort}) => {
    let currentPage = page || 1
    let perPage = per_page || 10
    let searchValue = search || ''
    let response
    try {
        response = await axios({
        method:'get',
        url:`/imports/${id}/reports?page=${currentPage}&sort=csv_id&direction=asc&per_page=${perPage}${searchValue? `&search=${searchValue}` : ''}`
    })}catch(e) {
        console.log(e)
    }
    return response.data
}
export const fetchImportInvoices = async ({id,page, search, per_page, sort}) => {
    let currentPage = page || 1
    let perPage = per_page || 10
    let searchValue = search || ''
    let response
    try {
        response = await axios({
        method:'get',
        url:`/imports/${id}/invoices?page=${currentPage}&sort=${sort.value}&direction=${sort.direction}&per_page=${perPage}${searchValue? `&search=${searchValue}` : ''}`
    })}catch(e) {
        console.log(e)
    }

    return response.data
}
